/** @jsx jsx */

import { Fragment } from 'react';
import { Icon } from '@zapier/zinnia-icons';
import { Colors, Spacer, Text } from '@zapier/design-system';
import { jsx, css } from '@emotion/core';

import Link from 'app/common/components/Link';
import { BASE_DOC_URL_VB } from 'app/developer-v3/constants';

import LifecycleDocLink from './LifecycleDocLink';
import { Footer as BaseFooter } from '../Layout';

const Styles = {
  root: css`
    border-top: 1px solid ${Colors.GrayWarm4};
    padding: 15px;
    display: flex;
    flex-wrap: wrap;
  `,
  header: css`
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  `,
};

type Props = {
  sectionId: ID;
};

function Footer({ sectionId }: Props) {
  const showLink = sectionId !== 'promote';
  return (
    <BaseFooter hasBorder={showLink}>
      <section css={Styles.header}>
        <Icon name="navHelpFill" size={20} />
        <Spacer width={10} />
        <Text type="Body1">Need help?</Text>
      </section>
      <Text>
        Check out the{' '}
        <Link href={`${BASE_DOC_URL_VB}/manage/versions`} target="_blank">
          version management guide
        </Link>
        {showLink && (
          <Fragment>
            {' '}
            and the <LifecycleDocLink sectionId={sectionId} />
          </Fragment>
        )}
        . If you run into any issues or errors contact us via the{' '}
        <Link href="https://developer.zapier.com/contact" target="_blank">
          help center
        </Link>
        .
      </Text>
    </BaseFooter>
  );
}

export default Footer;
